

import { useEffect, useState } from "react";



// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";


import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import MenuItem from '@mui/material/MenuItem';
import ReactHookFormSelect from "common/components/mycomponents/ReactHookFormSelect";


// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";
import MDInput from "common/components/MD/MDInput";
import MDTypography from "common/components/MD/MDTypography";

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthService from 'services/API/Auth/AuthService.js';
import { brandButtonOutlinedSx } from "common/assets/theme/components/brandButtonSx";



function ExpoRichiestaScegli({ scegli, onClose, show }) {

  /* ----------------------------FUNZIONALITA PAGINA------------------------------------------------- */

  /* ----------------------------CARICAMENTO E RIEMPIMENTO CAMPI------------------------------------------------- */
  /* ------------------------------navigazione -----------------------------------------------------------------*/

  const navigate = useNavigate();

  const [val, setVal] = useState("0");

  const handleKeyDown = (e) => {
    const { key, target } = e

    if (key !== "Enter" || target instanceof HTMLTextAreaElement) {
      return
    }

    e.preventDefault()
  }

  const scelta = () => {

    if (val === "0") {
      navigate("/expo_richiesteStart");
    } else if (val === "1") {
   //if(AuthService.getCurrentUser().id==28 || AuthService.getCurrentUser().id==40){
      navigate("/expo_richiesteAviStart");
    //}
      //else{
        //alert("L'iscrizione per gli avicunicoli sarà disponibile a breve!");
        // onClose();
      //}
    }

  }


  return (
    <Dialog open={show} onClose={onClose}>

      <MDBox pt={3} pb={3}>


        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card >

              <MDBox pt={1} pb={3} px={3} component="form" role="form" onKeyDown={handleKeyDown}>


                <CardContent>
                  <MDBox>
                    <MDBox mb={2}>

                      <MDButton variant="gradient" color="brand" fullWidth>
                        <MDTypography variant="h6" fontWeight="regular" sx={{
                          color: "#FFFFFF"
                        }}>Nuova richiesta di Partecipazione</MDTypography>
                      </MDButton>
                    </MDBox>



                    <MDBox mb={2}>
  <FormControl>
    <FormLabel id="manifestazione-label">
      <MDTypography variant="h6" fontWeight="regular">Vuoi partecipare a:</MDTypography>
    </FormLabel>
    <RadioGroup
      aria-labelledby="manifestazione-label"
      name="manifestazione"
      value={val}
      onChange={(e) => setVal(e.target.value)}
    >
      <FormControlLabel
        value="0"
        control={<Radio />}
        label="Mostra Agricoltura Zootecnia Alimentazione"
      />
      <FormControlLabel
        value="1"
        disabled
        control={<Radio inputProps={{ "aria-describedby": "nota-mostra-mercato" }} />}
        label={
          <MDBox lineHeight={1.3}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Mostra Mercato Animali da Cortile e Selvaggina
            </MDTypography>
            <MDTypography
              id="nota-mostra-mercato"
              variant="caption"
              display="block"
              sx={({ palette: { brand } }) => ({ color: brand.main, fontStyle: "italic" })}
            >
             Le Iscrizioni apriranno a breve
            </MDTypography>
          </MDBox>
        }
        sx={{ alignItems: "flex-start", "& .MuiRadio-root": { pt: 0.5 } }}
      />
    </RadioGroup>
  </FormControl>
</MDBox>

                  </MDBox>




                  <MDBox sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt={4} mb={1}>
                     <MDButton  variant="contained" sx={brandButtonOutlinedSx } onClick={onClose} type="button">
                      Chiudi
                    </MDButton>
                    <MDBox sx={{ flex: '1 1 auto' }} />
                    <MDBox ml={2}>

                    </MDBox>
                    <MDBox ml={2}>
                        <MDButton  variant="contained" sx={brandButtonOutlinedSx } onClick={scelta} type="button">Avanti</MDButton>
                    
                    </MDBox>

                  </MDBox>



                </CardContent>

              </MDBox>

            </Card>
          </Grid >
        </Grid >
      </MDBox >

    </Dialog>
  );
}

export default ExpoRichiestaScegli;
